//Función para descargar un archivo a partir de una URL.
export const downloadFileFromUrl = (url, nombreArchivo) => {
    //console.log("voy a descargar")
    // Realizar la petición para obtener el blob del archivo
    fetch(url)
    .then((response) => response.blob())
    .then((blob) => {

        // Crear un enlace <a> para descargar el archivo
        const enlace = document.createElement("a");
        enlace.href = URL.createObjectURL(blob);
        enlace.download = nombreArchivo; // Asignar el nombre del archivo
        enlace.style.display = "none";
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
      })
      .catch((error) => {
        console.error("Error al descargar el archivo:", error);
      });
};
